import React from "react";
import { useAppSelector } from "../../../store/hooks";
import { useLocation, Navigate, Outlet } from "react-router-dom";

/**
 * Route guard that redirects to /home if employee is not found (404 from fetchEmployeeDetails).
 * Allows /home to render, but blocks all other subroutes.
 */
const EmployeeErrorGuard: React.FC = () => {
  const isEmployeeNotFound = useAppSelector(
    (state) => state.employee.isEmployeeNotFound
  );
  const location = useLocation();

  if (isEmployeeNotFound && location.pathname !== "/home") {
    return <Navigate to="/home" replace />;
  }
  return <Outlet />;
};

export default EmployeeErrorGuard;
